import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BreakfastDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"breakfast_dining"}/>
}
